var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},_vm._l((_vm.titleList),function(item){return _c('div',{key:item.id,class:item.id == _vm.checkId? 'content-active':'content-title',on:{"click":function($event){return _vm.checkTitle(item)}}},[_vm._v(" "+_vm._s(item.name)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }